import React, { useState } from 'react';
import { Modal, Checkbox, Button, Space } from 'antd';

const ExportFieldsModal = ({ visible, onOk, onCancel }) => {
  const [selectedFields, setSelectedFields] = useState([
    'order_number',
    'express_number',
    'batch_number',
    'product_name',
    'weight_per_item',
    'quantity',
    'unit',
    'recipient_name',
    'recipient_province',
    'recipient_city',
    'recipient_district',
    'recipient_address',
    'recipient_phone',
    'sender_name',
    'sender_address',
    'sender_phone',
    'status',
    'airway_bill_number',
    'port',
    'courier_service',
    'created_at',
    'updated_at',
    'notes'
  ]);

  const allFields = [
    { key: 'order_number', label: '订单号' },
    { key: 'express_number', label: '快递单号' },
    { key: 'batch_number', label: '批次号' },
    { key: 'product_name', label: '品名' },
    { key: 'weight_per_item', label: '单件重量(KG)' },
    { key: 'quantity', label: '数量' },
    { key: 'unit', label: '单位' },
    { key: 'recipient_name', label: '收件人姓名' },
    { key: 'recipient_province', label: '收件人省' },
    { key: 'recipient_city', label: '收件人市' },
    { key: 'recipient_district', label: '收件人区' },
    { key: 'recipient_address', label: '收件人地址' },
    { key: 'recipient_phone', label: '收件人电话' },
    { key: 'customer', label: '客户' },
    { key: 'sender_name', label: '寄件人姓名' },
    { key: 'sender_address', label: '寄件人地址' },
    { key: 'sender_phone', label: '寄件人电话' },
    { key: 'status', label: '状态' },
    { key: 'airway_bill_number', label: '空运单号' },
    { key: 'port', label: '港口' },
    { key: 'courier_service', label: '快递公司' },
    { key: 'created_at', label: '创建时间' },
    { key: 'updated_at', label: '更新时间' },
    { key: 'notes', label: '备注' }
  ];

  const handleSelectAll = () => {
    setSelectedFields(allFields.map(field => field.key));
  };

  const handleUnselectAll = () => {
    setSelectedFields([]);
  };

  const handleOk = () => {
    onOk(selectedFields);
  };

  return (
    <Modal
      title="选择导出字段"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      width={600}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="ok" type="primary" onClick={handleOk}>
          导出
        </Button>
      ]}
    >
      <Space style={{ marginBottom: 16 }}>
        <Button onClick={handleSelectAll}>全选</Button>
        <Button onClick={handleUnselectAll}>取消全选</Button>
      </Space>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(3, 1fr)', 
        gap: '8px',
        maxHeight: '400px',
        overflowY: 'auto',
        padding: '8px'
      }}>
        {allFields.map(field => (
          <Checkbox
            key={field.key}
            checked={selectedFields.includes(field.key)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedFields([...selectedFields, field.key]);
              } else {
                setSelectedFields(selectedFields.filter(key => key !== field.key));
              }
            }}
          >
            {field.label}
          </Checkbox>
        ))}
      </div>
    </Modal>
  );
};

export default ExportFieldsModal;
